import React, { useCallback, useEffect, useState } from 'react';
import SaleRevenue from 'src/components/partials/default/sale-revenue/SaleRevenue';
import SalesOverview from 'src/components/partials/default/sales-overview/SalesOverview';
import ActionCenter from "src/components/partials/action-center/ActionCenter";
import * as Sentry from '@sentry/browser';

import { useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import Axios from "axios";
import { API_ROUTES } from "src/config/api";
import ExpiredOpenBanking from '../expired-open-banking';
import TopMerchants from '../top-merchants';
import ConversionFunnel from '../../../main/components/statistics/conversion-funnel';

const DashboardStatistics = () => {
  const { account } = useSelector((state) => state.account);
  const [currency, setCurrency] = useState('GBX');
  const [oldCurrency, setOldCurrency] = useState('GBX');

  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({
    thirty_day_payments: [],
    bookings: {
      day: 0,
      week: 0,
      month: 0,
      year_breakdown: [],
    },
    payment_links: {},
    pre_auth: {
      pending: 0,
    },
    transactions: {
      total: 0,
      declined: 0,
    },
    ledger: {},
    stats: {},
  });

  const { organisation } = useSelector((state) => state);

  const getData = useCallback(async () => {
    if (loaded === false) {
      setLoading(true);
    }

    try {
      const user = await Auth.currentAuthenticatedUser();

      let promises = [
        Axios(
          API_ROUTES.reporting['dashboard:group-statistics'](organisation.organisation, currency),
          {
            method: 'get',
            headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
          }
        ),
      ];

      const results = await Promise.all(promises);

      // Calculate transaction statistics
      const transactionsTotalWeekly = results[0].data.data.stats.transactions.status.weekly
        .reduce((partialSum, a) => partialSum + (a.status !== 'ABANDONED' && a.status !== 'PENDING' ? a.count : 0), 0);
      const transactionsDeclinedWeekly = results[0].data.data.stats.transactions.status.weekly
        .reduce((partialSum, a) => partialSum + (a.status === 'DECLINED' ? a.count : 0), 0);

      const paymentLinksTotalWeekly = results[0].data.data.stats.payment_links.status.weekly
        .reduce((partialSum, a) => partialSum + a.count, 0);
      const paymentLinksNotActiveWeekly = results[0].data.data.stats.payment_links.status.weekly
        .reduce((partialSum, a) => partialSum + (a.status !== 'active' ? a.count : 0), 0);

      setData({
        ...data,
        ...results[0].data.data,
        payment_links: {
          total: paymentLinksTotalWeekly,
          complete: paymentLinksNotActiveWeekly,
          percentageComplete: paymentLinksTotalWeekly === 0 || paymentLinksNotActiveWeekly === 0 ? 0 : ((paymentLinksNotActiveWeekly / paymentLinksTotalWeekly) * 100).toFixed(2),
        },
        pre_auth: results[0].data?.data?.stats?.pre_auth,
        transactions: {
          total: transactionsTotalWeekly,
          declined: transactionsDeclinedWeekly,
          percentageDeclined: transactionsTotalWeekly === 0 || transactionsDeclinedWeekly === 0 ? 0 : ((transactionsDeclinedWeekly / transactionsTotalWeekly) * 100).toFixed(2),
        },
      });

      setLoading(false);
      setLoaded(true);
      setOldCurrency(currency);
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [organisation.organisation, account, currency]);

  useEffect(() => {
    getData();
  }, [organisation.organisation, currency]);

  return (
    <React.Fragment>

      <div className='col-span-6 lg:col-span-4'>

        <SalesOverview
          data={data.thirty_day_payments}
          loading={loading}
          currency={currency}
          oldCurrency={oldCurrency}
          setCurrency={setCurrency}
        />

        <SaleRevenue data={data.bookings} loading={loading} />

        <ExpiredOpenBanking data={data} loading={loading} />

      </div>

      <div className='col-span-6 lg:col-span-2'>
        <ActionCenter data={data.stats} loading={loading} group={true} />

        <div className="mb-1" />

        <ConversionFunnel data={data.stats} loading={loading} />

        <div className="mb-1" />

        <TopMerchants data={data} loading={loading} />

      </div>

    </React.Fragment>
  );
}
export default DashboardStatistics;
